// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(640px, 90vw);
  height: 100vh;
  background: var(--ui-surface);
  border-left: 1px solid var(--ui-border);
  box-shadow: -8px 0 24px rgba(16, 24, 40, 0.12);
  padding: 32px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: appDrawerSlideIn 0.25s ease;
}

.app-drawer--wide {
  width: min(780px, 92vw);
}

.app-drawer__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.app-drawer__header > h4 {
  color: var(--ui-primary);
  border-bottom: 2px solid rgba(3, 78, 162, 0.2);
  width: auto;
  padding-bottom: 6px;
  font-size: 18px;
}

.app-drawer__body {
  overflow: auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.app-drawer__body--grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  align-content: start;
}

.app-drawer__row {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid var(--ui-border);
}

.app-drawer__row .label {
  color: var(--ui-muted);
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.app-drawer__row .value {
  color: var(--ui-text);
  font-weight: 600;
  font-size: 16px;
  text-align: left;
  word-break: break-word;
}

.app-drawer__section {
  grid-column: 1 / -1;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--ui-border);
}

.app-drawer__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.app-drawer__section-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--ui-text);
  margin: 0;
}

.app-drawer__table {
  width: 100%;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  overflow: hidden;
}

.app-drawer__table {
  display: grid;
  gap: 10px;
  background: transparent;
}

.app-drawer__table-row {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr 0.9fr 1fr;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  background: #fbfcff;
}

.app-drawer__table-row.header {
  background: transparent;
  border: none;
  padding: 0 2px 2px;
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 600;
  color: var(--ui-muted);
}

.app-drawer__table-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
  word-break: break-word;
}

.app-drawer__table-cell span {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--ui-muted);
  font-weight: 600;
}

.app-drawer__file-link {
  color: var(--ui-primary);
  text-decoration: none;
  font-weight: 600;
}

.app-drawer__file-link:hover {
  text-decoration: underline;
}

.app-drawer__empty {
  padding: 12px;
  color: var(--ui-muted);
  font-size: 13px;
}

.app-drawer__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drawer-edit-button {
  border: 1px solid var(--ui-primary);
  background: var(--ui-surface);
  color: var(--ui-primary);
  border-radius: var(--ui-radius-md);
  padding: 6px 12px;
  font-weight: 600;
  cursor: pointer;
}

.drawer-edit-button:hover {
  background: rgba(3, 78, 162, 0.06);
}

.app-drawer__close {
  border: none;
  cursor: pointer;
  font-size: 25px;
  font-weight: 100;
  line-height: 1;
  background: transparent;
}

.app-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.25);
  z-index: 999;
  animation: appDrawerFadeIn 0.2s ease;
}

@keyframes appDrawerSlideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes appDrawerFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Drawer/drawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,uCAAuC;EACvC,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".app-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: min(640px, 90vw);\n  height: 100vh;\n  background: var(--ui-surface);\n  border-left: 1px solid var(--ui-border);\n  box-shadow: -8px 0 24px rgba(16, 24, 40, 0.12);\n  padding: 32px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  animation: appDrawerSlideIn 0.25s ease;\n}\n\n.app-drawer--wide {\n  width: min(780px, 92vw);\n}\n\n.app-drawer__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.app-drawer__header > h4 {\n  color: var(--ui-primary);\n  border-bottom: 2px solid rgba(3, 78, 162, 0.2);\n  width: auto;\n  padding-bottom: 6px;\n  font-size: 18px;\n}\n\n.app-drawer__body {\n  overflow: auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.app-drawer__body--grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  align-content: start;\n}\n\n.app-drawer__row {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  background: transparent;\n  border-bottom: 1px solid var(--ui-border);\n}\n\n.app-drawer__row .label {\n  color: var(--ui-muted);\n  font-weight: 500;\n  font-size: 12px;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.app-drawer__row .value {\n  color: var(--ui-text);\n  font-weight: 600;\n  font-size: 16px;\n  text-align: left;\n  word-break: break-word;\n}\n\n.app-drawer__section {\n  grid-column: 1 / -1;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--ui-border);\n}\n\n.app-drawer__section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.app-drawer__section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ui-text);\n  margin: 0;\n}\n\n.app-drawer__table {\n  width: 100%;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  overflow: hidden;\n}\n\n.app-drawer__table {\n  display: grid;\n  gap: 10px;\n  background: transparent;\n}\n\n.app-drawer__table-row {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr 0.9fr 1fr;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  background: #fbfcff;\n}\n\n.app-drawer__table-row.header {\n  background: transparent;\n  border: none;\n  padding: 0 2px 2px;\n  font-size: 11px;\n  text-transform: none;\n  letter-spacing: 0.2px;\n  font-weight: 600;\n  color: var(--ui-muted);\n}\n\n.app-drawer__table-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: var(--ui-text);\n  font-size: 13px;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.app-drawer__table-cell span {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--ui-muted);\n  font-weight: 600;\n}\n\n.app-drawer__file-link {\n  color: var(--ui-primary);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.app-drawer__file-link:hover {\n  text-decoration: underline;\n}\n\n.app-drawer__empty {\n  padding: 12px;\n  color: var(--ui-muted);\n  font-size: 13px;\n}\n\n.app-drawer__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.drawer-edit-button {\n  border: 1px solid var(--ui-primary);\n  background: var(--ui-surface);\n  color: var(--ui-primary);\n  border-radius: var(--ui-radius-md);\n  padding: 6px 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.drawer-edit-button:hover {\n  background: rgba(3, 78, 162, 0.06);\n}\n\n.app-drawer__close {\n  border: none;\n  cursor: pointer;\n  font-size: 25px;\n  font-weight: 100;\n  line-height: 1;\n  background: transparent;\n}\n\n.app-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.25);\n  z-index: 999;\n  animation: appDrawerFadeIn 0.2s ease;\n}\n\n@keyframes appDrawerSlideIn {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes appDrawerFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
